<template>
        <div class="container"> 
            <slot/>
        </div>
</template>
<script>
export default {
    name:'ContainerApp'
}
</script>